import { Component, AfterViewInit, ChangeDetectorRef, ViewChild, TemplateRef} from '@angular/core';
import { context } from '../../contexts/context';

@Component({
  selector: 'cnaf-contactermacaf-complet',
  templateUrl: './contactermacafcomplet.component.html',
  styleUrls: ['./contactermacafcomplet.component.css']
})
export class ContacterMaCafCompletComponent implements AfterViewInit {

  @ViewChild('wrapper') wrapper!: { componentTemplate: TemplateRef<any> };
  contexte: string;

  constructor(
    private readonly changeDetectorRef: ChangeDetectorRef) {
    this.contexte = context.type;
  }

  ngAfterViewInit(): void {
    this.changeDetectorRef.detectChanges();
  }
}
